"use client";

import { JsonLD } from "@/components/common/json-ld";
import { valuesWithAppName } from "@/lib/i18n";
import { formatLocation } from "@/lib/locations";
import type { DetailedListingListItem } from "@/lib/types";
import type { SearchHookLocation } from "@repo/maps";
import { useTranslations } from "next-intl";

export type BusinessesJsonLDProps = {
  listings: DetailedListingListItem[];
  location?: SearchHookLocation;
};

export function BusinessesJsonLD({
  listings,
  location,
}: BusinessesJsonLDProps) {
  const t = useTranslations();

  const items = listings
    .filter((listing) => listing.locationTier !== "AREA")
    .slice(0, 10)
    .map((listing) => `/business/${listing.slug}`);

  const formattedLocation = location ? formatLocation(location) : undefined;

  const name = t(
    location
      ? "saas.search.metadata.withLocation.title"
      : "saas.search.metadata.withoutLocation.title",
    valuesWithAppName(t, {
      location: formattedLocation ?? "N/A",
    }),
  );

  const description = t(
    location
      ? "saas.search.metadata.withLocation.description"
      : "saas.search.metadata.withoutLocation.description",
    valuesWithAppName(t, {
      location: formattedLocation ?? "N/A",
      count: listings.length,
    }),
  );

  return (
    <JsonLD
      type="CollectionPage"
      name={name}
      description={description}
      mainEntityData={{
        "@type": "CollectionPage",
        mainEntity: {
          itemListUrls: items,
        },
      }}
    />
  );
}
